import script from "./FinalSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalSetting.vue?vue&type=script&setup=true&lang=ts"

import "./FinalSetting.vue?vue&type=style&index=0&id=55d92a24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d92a24"]])

export default __exports__